/**
 * FAQ Accordion — Daisy Connected Shop
 * Ported from WP theme faq-accordion.js.
 * Smooth UX enhancements for details/summary elements.
 */

(function () {
  'use strict';

  var detailsElements = document.querySelectorAll('.accordion details');
  if (!detailsElements.length) return;

  /**
   * Scroll into view if the opened details element is above viewport.
   */
  function handleToggle(event) {
    var details = event.target;
    if (!details.open) return;

    var rect = details.getBoundingClientRect();
    if (rect.top < 100) {
      details.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  }

  /**
   * Keyboard navigation — Enter and Space toggle.
   */
  function handleKeyDown(event) {
    var summary = event.target;
    if (summary.tagName !== 'SUMMARY') return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      summary.click();
    }
  }

  detailsElements.forEach(function (details) {
    details.addEventListener('toggle', handleToggle);
  });

  var summaryElements = document.querySelectorAll('.accordion summary');
  summaryElements.forEach(function (summary) {
    summary.addEventListener('keydown', handleKeyDown);
  });
})();
